import fetchItemDescription from '../Services/fetchItemDescriptions';

export default () => async (dispatch) => {

  dispatch(fetchItemDescription());

}